<div class="message-detail-container mb-5">
  <!-- Header -->
  <div class="message-header d-flex justify-content-between align-items-center mb-3">
    <h4 class="m-0">Dettaglio Evento</h4>
    <button mat-icon-button (click)="closeBottomSheet()" aria-label="Chiudi">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <h2 class="message-title mb-3">
    {{ data.fiscalEvent.name || 'Nessun titolo' }}
  </h2>

  <!-- Sender and Date -->
  <div class="message-meta mb-4">
    <p class="m-0 text-muted">
      <strong>Data evento:</strong> {{ data.fiscalEvent.date | date:'dd/MM/yyyy' }}
    </p>
    <p class="m-0 text-muted" *ngIf="data.fiscalEvent.type !== 'CREDITO'">
      <strong>Importo:</strong> {{ data.fiscalEvent.amount || 'Sconosciuto' }}
    </p>
    <p class="m-0 text-muted" *ngIf="data.fiscalEvent.type === 'CREDITO'">
      <strong>Importo:</strong> {{ (-data.fiscalEvent.amount) || 'Sconosciuto' }}
    </p>
    <p class="m-0 text-muted" *ngIf="data.fiscalEvent.type !== 'CREDITO'">
    <strong>Stato:</strong> {{data.fiscalEvent.is_paid ? 'Saldato' : 'Non saldato'}}
    </p>
  </div>

  <mat-divider class="mb-4"></mat-divider>

  <!-- Descrizione -->
  <div class="message-content mb-4">
    <h5 class="mb-3">Descrizione evento:</h5>
    <div class="message-text">
      {{ eventExplanationText }}
    </div>
  </div>

  <p 
    *ngIf="!data.fiscalEvent.is_paid && data.fiscalEvent.type !== 'CREDITO'"
    class="text-muted"
  >
  Segnando l'evento come "Pagato" con l'apposito check, permetterai all'algoritmo di generare previsioni più accurate.
  </p>
  <p 
    *ngIf="data.fiscalEvent.is_paid && data.fiscalEvent.type === 'CONTRIBUTI'"
    class="text-muted"
  >
  Questo evento risulta saldato, pertanto concorre al calcolo di contributi deducibili per l'anno successivo. Ottimo!
  </p>
  <p 
    *ngIf="data.fiscalEvent.is_paid && data.fiscalEvent.type === 'TASSE'"
    class="text-muted"
  >
  Questo evento risulta saldato.
  </p>

</div>

<div class="pt-3 mb-3"></div>
